(function () {
  'use strict';

  var TOTAL        = 147;
  var PX_PER_FRAME = 4;
  var FRICTION     = 0.92;
  var INERTIA_THRESHOLD = 0.2;
  var INERTIA_STOP = 0.03;
  var VEL_BUFFER_MS = 80;
  var INTRO_HALF   = Math.round(TOTAL * 150 / 360); // ~61 frames = 150°
  var INTRO_MS     = 1680;

  function pad4(n) {
    return ('000' + n).slice(-4);
  }

  function init(container) {
    var img = container.querySelector('[data-bs360-img]');
    if (!img) return;

    var baseUrl = container.dataset.baseUrl;
    if (!baseUrl) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function frameUrl(n) {
      return baseUrl + 'bag_' + pad4(n) + '.jpg';
    }

    function wrapFrame(n) {
      return ((n - 1) % TOTAL + TOTAL) % TOTAL + 1;
    }

    // ── State ─────────────────────────────────────────────────────────────────

    var currentFrame = 1;
    var dragStartX   = null;
    var dragStartFrame = 1;
    var inertiaId    = null;
    var preloaded    = false;
    var introRaf     = null;

    // ── Velocity buffer ───────────────────────────────────────────────────────

    var velBuf = [];

    function trackVel(x) {
      var t = performance.now();
      velBuf.push({ t: t, x: x });
      var cut = t - VEL_BUFFER_MS;
      while (velBuf.length > 1 && velBuf[0].t < cut) velBuf.shift();
    }

    function getVel() {
      if (velBuf.length < 2) return 0;
      var a = velBuf[0], b = velBuf[velBuf.length - 1];
      var dt = b.t - a.t;
      return dt < 5 ? 0 : (b.x - a.x) / dt;
    }

    // ── Frame display ─────────────────────────────────────────────────────────

    function setFrame(n) {
      var f = wrapFrame(n);
      if (f === currentFrame) return;
      currentFrame = f;
      img.src = frameUrl(f);
    }

    // ── Preload ───────────────────────────────────────────────────────────────

    function preloadAll() {
      if (preloaded) return;
      preloaded = true;
      for (var i = 2; i <= TOTAL; i++) {
        (new Image()).src = frameUrl(i);
      }
    }

    // ── Inertia ───────────────────────────────────────────────────────────────

    function cancelInertia() {
      if (inertiaId !== null) { cancelAnimationFrame(inertiaId); inertiaId = null; }
    }

    function startInertia(velPxMs) {
      var vel = velPxMs / PX_PER_FRAME;
      var driftPos = currentFrame;
      var lastT = performance.now();

      function step(now) {
        var dt = Math.min(now - lastT, 64);
        lastT = now;
        vel *= Math.pow(FRICTION, dt / 16.67);
        if (Math.abs(vel * PX_PER_FRAME) < INERTIA_STOP) { inertiaId = null; return; }
        driftPos += vel * dt;
        var f = wrapFrame(Math.round(driftPos));
        if (f !== currentFrame) { currentFrame = f; img.src = frameUrl(f); }
        inertiaId = requestAnimationFrame(step);
      }

      inertiaId = requestAnimationFrame(step);
    }

    // ── Drag-end ──────────────────────────────────────────────────────────────

    function onDragEnd() {
      if (dragStartX === null) return;
      var vel = getVel();
      dragStartX = null;
      velBuf = [];
      if (reducedMotion) return;
      if (Math.abs(vel) >= INERTIA_THRESHOLD) startInertia(vel);
    }

    // ── Hint ─────────────────────────────────────────────────────────────────

    var hint      = container.querySelector('[data-bs360-hint]');
    var hintShown = false;
    var hintTimer = null;

    function hideHint() {
      if (!hint || hintShown) return;
      clearTimeout(hintTimer);
      hint.classList.remove('bs-bag__hint--visible');
      hintShown = true;
    }

    function showHint() {
      if (!hint || hintShown) return;
      hint.classList.add('bs-bag__hint--visible');
      hintTimer = setTimeout(hideHint, 3500);
    }

    // ── Intro animation ───────────────────────────────────────────────────────

    function cancelIntro() {
      if (introRaf !== null) { cancelAnimationFrame(introRaf); introRaf = null; }
    }

    function easeInOut(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function runIntro() {
      showHint();

      if (reducedMotion) {
        // No animation — just show pill and preload
        setTimeout(preloadAll, 300);
        return;
      }

      var startTs = null;

      function introStep(ts) {
        if (!startTs) startTs = ts;
        var progress = Math.min((ts - startTs) / INTRO_MS, 1);
        var frame = Math.round(easeInOut(progress) * (INTRO_HALF - 1)) + 1;
        setFrame(frame);

        if (progress < 1) {
          introRaf = requestAnimationFrame(introStep);
        } else {
          introRaf = null;
          setTimeout(preloadAll, 100);
        }
      }

      introRaf = requestAnimationFrame(introStep);
    }

    // ── Intro trigger: Frames vorabladen, dann bei 40 % Viewport starten ────
    //
    // Race condition fix: IntersectionObserver feuert oft bevor die
    // Frame-Images geladen sind → Intro ruckelt oder springt.
    //
    // Lösung: zweistufig.
    //   10 % sichtbar → Intro-Frames (2..INTRO_HALF) vorab laden
    //   40 % sichtbar → Intro starten, sobald Frames bereit sind

    var introFramesNeeded = INTRO_HALF; // Frame 1 bereits in img.src
    var introFramesReady  = 1;
    var introPreloadDone  = false;
    var inViewport        = false;
    var introFired        = false;

    function maybeStartIntro() {
      if (introFired) return;
      if (!inViewport) return;
      if (!reducedMotion && introFramesReady < introFramesNeeded) return;
      introFired = true;
      runIntro();
    }

    function startIntroPreload() {
      if (introPreloadDone) return;
      introPreloadDone = true;
      if (reducedMotion) { maybeStartIntro(); return; }
      for (var i = 2; i <= INTRO_HALF; i++) {
        (function (f) {
          var pi = new Image();
          pi.onload = pi.onerror = function () {
            introFramesReady++;
            maybeStartIntro();
          };
          pi.src = frameUrl(f);
        })(i);
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var ratio = entries[0].intersectionRatio;
        if (ratio >= 0.1) startIntroPreload();
        if (ratio >= 0.4 && !inViewport) {
          io.disconnect();
          inViewport = true;
          maybeStartIntro();
        }
      }, { threshold: [0.1, 0.4] });
      io.observe(container);
    } else {
      inViewport = true;
      startIntroPreload();
    }

    // ── Mouse ─────────────────────────────────────────────────────────────────

    container.addEventListener('mousedown', function (e) {
      e.preventDefault();
      cancelIntro();
      cancelInertia();
      hideHint();
      velBuf = [];
      dragStartX = e.clientX;
      dragStartFrame = currentFrame;
    });

    window.addEventListener('mousemove', function (e) {
      if (dragStartX === null) return;
      trackVel(e.clientX);
      setFrame(dragStartFrame + Math.round((e.clientX - dragStartX) / PX_PER_FRAME));
    });

    window.addEventListener('mouseup', onDragEnd);

    // ── Touch ─────────────────────────────────────────────────────────────────

    var touchStartX    = null;
    var touchStartY    = null;
    var intentDetected = false;

    container.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      intentDetected = false;
      dragStartX = null;
    }, { passive: true });

    container.addEventListener('touchmove', function (e) {
      if (touchStartX === null) return;
      var x = e.touches[0].clientX;
      var y = e.touches[0].clientY;

      if (!intentDetected) {
        var dx = x - touchStartX;
        var dy = y - touchStartY;
        if (Math.abs(dx) <= Math.abs(dy) * 1.5) return;
        intentDetected = true;
        cancelIntro();
        cancelInertia();
        hideHint();
        velBuf = [];
        dragStartX = x;
        dragStartFrame = currentFrame;
      }

      e.preventDefault();
      trackVel(x);
      setFrame(dragStartFrame + Math.round((x - dragStartX) / PX_PER_FRAME));
    }, { passive: false });

    container.addEventListener('touchend', function () {
      touchStartX = null;
      touchStartY = null;
      onDragEnd();
    });

    container.addEventListener('touchcancel', function () {
      touchStartX = null;
      touchStartY = null;
      dragStartX  = null;
      velBuf = [];
    });
  }

  document.querySelectorAll('[data-bs-bag-360]').forEach(init);
})();
